export default __webpack_public_path__ + "3f81daca36833d40686ea5b771d61e0a.png";